import { render, staticRenderFns } from "./SupplierContactForm.vue?vue&type=template&id=ba4fe584"
import script from "./SupplierContactForm.vue?vue&type=script&lang=js"
export * from "./SupplierContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports